(function () {

  function findHeader() {
    return document.querySelector('.row-header');
  }

  function closeThemeMenu(wrapper) {
    var dropdown = wrapper.closest('.site-nav__dropdown');
    if (!dropdown) return;
    var navItem = dropdown.closest('.site-nav__item');
    dropdown.style.display = 'none';
    setTimeout(function () {
      dropdown.style.display = '';
    }, 50);
    if (navItem) {
      navItem.classList.remove('is-active', 'active', 'open', 'js-open');
    }
    dropdown.classList.remove('is-active', 'active', 'open', 'js-open');
  }

  // --- AJAX 缓存与核心抓取函数 ---
  var ajaxCache = {};
  
  // 【新增】：用一个内存对象记录正在请求的 handle，这是绝对安全的并发锁
  var activeRequests = {}; 

  function loadProductsForPanel(panel) {
    if (!panel) return;
    
    // 1. 如果已经加载完数据了，直接跳过
    if (panel.getAttribute('data-loaded') === 'true') return;
    
    var handle = panel.getAttribute('data-col-handle');
    var limit = panel.getAttribute('data-limit') || 12;
    if (!handle || handle === '') return;

    // 如果有缓存，直接渲染
    if (ajaxCache[handle]) {
      renderAjaxProducts(panel, ajaxCache[handle]);
      return;
    }

    // 2. 【更健壮的锁】：如果这个 handle 已经在请求中了，直接跳过。
    // 这比写在 DOM 属性里安全得多，不会因为鼠标乱晃导致死锁。
    if (activeRequests[handle]) return;

    // 标记为正在请求
    activeRequests[handle] = true;

    // 发起请求抓取产品的 JSON 数据
    var url = '/collections/' + handle + '/products.json?limit=' + limit;
    fetch(url)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        // 数据回来了，立刻解锁
        delete activeRequests[handle];
        
        if (data && data.products) {
          ajaxCache[handle] = data.products;
          renderAjaxProducts(panel, data.products);
        }
      })
      .catch(function(err) {
        // 就算报错了，也要解锁，保证下次还能重试
        delete activeRequests[handle];
        console.error('Failed to fetch AJAX products for ' + handle, err);
      });
  }

  function renderAjaxProducts(panel, products) {
      if (panel.getAttribute('data-loaded') === 'true') {
    return;
  }
    panel.setAttribute('data-loaded', 'true');
    var grid = panel.querySelector('.mm3col-products__grid');
    if (!grid) return;
    
    // 移除骨架屏和 loading 动画
    grid.innerHTML = '';
    grid.classList.remove('mm3col-products__grid--skeleton');

    if (products.length === 0) {
      grid.innerHTML = '<div style="grid-column: 1 / -1; padding: 20px; text-align: center; opacity: 0.5;">No products found.</div>';
      return;
    }

    var html = '';
    products.forEach(function(product, index) {
      var imgSrc = (product.images && product.images.length > 0) ? product.images[0].src : '';
      if (imgSrc) {
        // Shopify 图片转尺寸技巧，避免加载过大原图
        imgSrc = imgSrc.replace(/\.(png|jpg|jpeg|gif|webp)(\?.*)?$/, '_300x300.$1$2');
      }
      var price = (product.variants && product.variants.length > 0) ? product.variants[0].price : '0.00';
      
      // 注意这里加入了渐进式展现动画延迟：animation-delay
      html += `
        <div class="mm3col-products__card" style="animation-delay: ${index * 0.05}s">
          <a href="/products/${product.handle}">
            ${imgSrc ? `<img src="${imgSrc}" alt="${product.title}" loading="lazy">` : ''}
            <span class="mm3col-products__name">${product.title}</span>
            <span class="mm3col-products__price">$${price}</span>
          </a>
        </div>
      `;
    });

    grid.innerHTML = html;
  }

  // --- 初始化原有逻辑 ---
  document.querySelectorAll('.mm3col-wrapper').forEach(function (wrapper) {
    var topNavItems = Array.from(wrapper.querySelectorAll('.mm3col-nav__list > .mm3col-nav__item'));
    var colItems    = Array.from(wrapper.querySelectorAll('.mm3col-collections__item'));
    var navPanels   = Array.from(wrapper.querySelectorAll('.mm3col-products__panel--nav'));
    var colPanels   = Array.from(wrapper.querySelectorAll('.mm3col-products__panel--col'));

    var colHoverTimer = null;
    var closeTimer    = null;
    var initialized   = false;

    function initLayout() {
      var menuTop = wrapper.getBoundingClientRect().top;
      var h = window.innerHeight - menuTop;
      if (h <= 100) return;
      
      wrapper.style.height = h + 'px';
      var dropdown = wrapper.closest('.site-nav__dropdown');
      if (dropdown) {
        dropdown.style.maxHeight = h + 'px';
        dropdown.style.overflow = 'hidden';
      }
      
      initialized = true;

      // 在菜单高度初始化完成、真正展开的这一瞬间，去抓取当前显示着的那个面板的产品
      var activePanel = Array.from(wrapper.querySelectorAll('.mm3col-products__panel')).find(function(p) {
        return p.style.display !== 'none';
      });
      if (activePanel) {
        loadProductsForPanel(activePanel);
      }
    }

    function hideAll() {
      navPanels.forEach(function (p) { p.style.display = 'none'; });
      colPanels.forEach(function (p) { p.style.display = 'none'; });
      colItems.forEach(function (c) { c.classList.remove('mm3col-collections__item--active'); });
      topNavItems.forEach(function (n) { n.classList.remove('mm3col-nav__item--active'); });
    }

    function showNavPanel(index) {
      if (colHoverTimer) { clearTimeout(colHoverTimer); colHoverTimer = null; }
      hideAll();
      if (topNavItems[index]) topNavItems[index].classList.add('mm3col-nav__item--active');
      var panel = navPanels[index] || colPanels[0];
      if (panel) {
        panel.style.display = 'block';
        loadProductsForPanel(panel);
      }
    }

    function showColPanel(index, colItem) {
      hideAll();
      colItem.classList.add('mm3col-collections__item--active');
      if (colPanels[index]) {
        colPanels[index].style.display = 'block';
        loadProductsForPanel(colPanels[index]);
      }
    }

    // 新增一个变量用来记录左侧菜单的延迟器
    var navHoverTimer = null;

    topNavItems.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () {
        // 当鼠标进入时，先清除之前的计时器
        if (navHoverTimer) { clearTimeout(navHoverTimer); navHoverTimer = null; }
        
        // 设定 150毫秒 的延迟防误触
        navHoverTimer = setTimeout(function () { 
          showNavPanel(i); 
        }, 150);
      });
      
      // 当鼠标在 150 毫秒内离开（意味着可能是不小心划过），就取消切换
      item.addEventListener('mouseleave', function () {
        if (navHoverTimer) { clearTimeout(navHoverTimer); navHoverTimer = null; }
      });
    });

    colItems.forEach(function (col, i) {
      col.addEventListener('mouseenter', function () {
        colHoverTimer = setTimeout(function () { showColPanel(i, col); }, 200);
      });
      col.addEventListener('mouseleave', function () {
        if (colHoverTimer) { clearTimeout(colHoverTimer); colHoverTimer = null; }
      });
    });

    var observeDropdown = wrapper.closest('.site-nav__dropdown');
    var observeTarget = observeDropdown ? observeDropdown.parentElement : wrapper.parentElement;
    if (observeTarget) {
      new MutationObserver(function () {
        if (!initialized) {
          var rect = wrapper.getBoundingClientRect();
          if (rect.height > 0 && rect.top > 0) {
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                initLayout();
              });
            });
          }
        }
      }).observe(observeTarget, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'open']
      });
    }

    window.addEventListener('resize', function () {
      initialized = false;
      wrapper.style.height = '';
      if (observeDropdown) observeDropdown.style.maxHeight = '';
      requestAnimationFrame(function () { initLayout(); });
    });

    var header = findHeader();
    if (header) {
      var headerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            if (closeTimer) clearTimeout(closeTimer);
            closeTimer = setTimeout(function () {
              closeThemeMenu(wrapper);
            }, 600);
          } else {
            if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          }
        });
      }, { threshold: 0.1 });
      headerObserver.observe(header);
    }

    // 初始状态下把第一个面板标为 display:block，但不去抓取数据
    if (navPanels[0]) {
      navPanels[0].style.display = 'block';
      if (topNavItems[0]) topNavItems[0].classList.add('mm3col-nav__item--active');
    } else if (colPanels[0]) {
      colPanels[0].style.display = 'block';
      if (colItems[0]) colItems[0].classList.add('mm3col-collections__item--active');
    }
  });
})();
